import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Type } from "../../utils";

type Result = string | number | boolean;
export interface IButton {
    label: string;
    value?: Result;
    isPrimary?: boolean;
}

 interface IFormPromptProps {
    title?: string;
    message?: string;
    buttons?: IButton[];
    children?: React.ReactNode;
    onPrompt: (value: Result) => void;
}

type IState = {
    prompt: IFormPromptProps | null;
}

export class PromptContainer extends React.Component {

    state: IState = {
        prompt: null
    }

    public static instance?: PromptContainer;

    UNSAFE_componentWillMount() {
        PromptContainer.instance = this;
    }

    UNSAFE_componentWillUnmount() {
        delete PromptContainer.instance;
    }

    public async prompt(title: string, message: string, buttons?: IButton[]): Promise<Result> {
        const self = this;
        return new Promise<Result>(resolve => {
            const state = {
                title: title,
                message: message,
                buttons: buttons,
                onPrompt: (result: Result) => {
                    self.setState({ prompt: null });
                    resolve(result);
                }
            };
            self.setState({ prompt: state });
        });
    }

    render() {
        const props = this.state.prompt;
        if (!props)
            return null;

        const message = () => {
            if (!props.message)
                return null;
            else if (Type.isString(props.message))
                return <p>{props.message}</p>;
            else
                return props.message;
        }

        const buttons = props.buttons ? props.buttons : defaultYesNoButtons;
        return (
            <Modal isOpen={true} >
                { props.title ?
                    <ModalHeader>
                        <b>{props.title}</b>
                    </ModalHeader>
                    : null
                }

                <ModalBody>
                    {message()}
                </ModalBody>

                <ModalFooter>
                    {
                        buttons.map((b, i) =>
                            <Button key={i} type="button" className={b.isPrimary ? "btn btn-primary" : "btn"}
                                onClick={() => props.onPrompt(b.value !== undefined ? b.value : b.label)}>{b.label}</Button>)
                    }
                </ModalFooter>
            </Modal>
        );
    }
}

const defaultYesNoButtons: IButton[] = [
    { label: 'No', value: false },
    { label: 'Yes', value: true, isPrimary: true }
];

export const prompt = async (title: string, message: string, buttons?: IButton[]): Promise<Result> => {
    if (PromptContainer.instance)
        return await PromptContainer.instance.prompt(title, message, buttons);
    else
        return '???';    
}
